import { matchPath, useLocation } from 'react-router-dom';

export const useIsExactPath = (path: string, end?: boolean) => {
  const { pathname } = useLocation();

  const isExactPath = !!matchPath({ end: end ?? true, path }, pathname);

  return isExactPath;
};
